module.exports = __webpack_public_path__ + "img/arrow_right.68e2c0e6.svg";